import {
  // EDIT_PROFILE,
  // EDIT_PROFILE_SUCCESS,
  // EDIT_PROFILE_FAIL,
  GET_PROFILE_GRP_USER,
  GET_PROFILE_GRP_USER_SUCCESS,
  GET_PROFILE_GRP_USER_FAIL,
  CLEAR_ACTION_RESULT
} from "./actionTypes"

// export const editProfile = astroUser => {
//   return {
//     type: EDIT_PROFILE,
//     payload: { astroUser },
//   }
// }

// export const editProfileSuccess = msg => {
//   return {
//     type: EDIT_PROFILE_SUCCESS,
//     payload: msg,
//   }
// }

// export const editProfileError = error => {
//   return {
//     type: EDIT_PROFILE_FAIL,
//     payload: error,
//   }
// }

export const getProfileForGRPUser = () => ({
  type: GET_PROFILE_GRP_USER,
})

export const getProfileForGRPUserSuccess = astroUser => ({
  type: GET_PROFILE_GRP_USER_SUCCESS,
  payload: astroUser,
})

export const getProfileForGRPUserFail = error => ({
  type: GET_PROFILE_GRP_USER_FAIL,
  payload: error,
})

export const clearActionResult = () => ({
  type: CLEAR_ACTION_RESULT,
})